export default "__VITE_ASSET__223cff7e__"